import { render } from "./IndexFooter.vue?vue&type=template&id=d3c15c66&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"

import "./IndexFooter.vue?vue&type=style&index=0&id=d3c15c66&scoped=true&lang=css"

import exportComponent from "/home/misserver/Documents/akred/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c15c66"]])

export default __exports__